import React, { useContext, useEffect, useState } from 'react'
import { Accordion, Card } from 'react-bootstrap';
import ReactDOM from 'react-dom'
import utilsCategurys from '../../../../../MyConns/_Utils/utilsCategurys';
import { RestContext } from '../../../../MyContexts/Rest_Context';
import CatsCheckslist from '../../../CategurysP/Categurys-list/CatsCheckslist';
import RichTextComp from '../../../../MySections/TextEditor/RichText';
import CRTypeSelect from '../../../../MySections/DTechComps/CRTypeSelect';

const TabBuisDetails = (props) => {
    const [rest, setRest] = useContext(RestContext);

    const [buissName, setBuissName] = useState(rest.buissName);
    const [buissPhone, setBuissPhone] = useState(rest.buissPhone);
    const [txtBuisKosher, setTxtBuisKosher] = useState(rest.txtBuisKosher);
    const [buissKitchType, setBuissKitchType] = useState(rest.buissKitchType);
    const [buissAbout, setBuissAbout] = useState(rest.buissAbout);
    const [buissMoreText, setBuissMoreText] = useState(rest.buissMoreText);
    const [CRType, setcRType] = useState(rest.CRType);
    const [gammaCnt, setGammaCnt] = useState(rest.gammaCnt);
    const [gammaSecret, setGammaSecret] = useState(rest.gammaSecret);
    const [gammaJ5, setGammaJ5] = useState(rest.gammaJ5);
    const [cashRegId, setCashRegId] = useState(rest.cashRegId);




    useEffect(() => {
    }, [])

    const aboutTxtChanged = (content) => {
        rest.buissAbout = content;
        setBuissAbout(content);
        //חובה על ריץ' טקסט
        setRest({ ...rest });
    }
    const moreTxtChanged = (content) => {

        rest.buissMoreText = content;
        setBuissMoreText(content);
        //חובה על ריץ' טקסט
        setRest({ ...rest });
    }
    return (
        <>

            <div className={"col-md-6 mb-2"}>
                <label htmlFor={"validationCustom1_1"}>שם העסק</label>
                <div className={"input-group"}>
                    <input type="text" className={"form-control"} id={"validationCustom1_1"} placeholder={"שם העסק"} value={buissName}
                        onChange={(e) => { rest["buissName"] = e.target.value; setBuissName(e.target.value) }} />
                </div>
            </div>
            <div className={"col-md-6 mb-2"}>
                <label htmlFor={"validationCustom1_4"}>טלפון ראשי</label>
                <div className={"input-group"}>
                    <input type="text" className={"form-control"} id={"validationCustom1_4"} placeholder={"טלפון"} value={buissPhone}
                        onChange={(e) => { rest["buissPhone"] = e.target.value; setBuissPhone(e.target.value) }} />

                </div>
            </div>
            <div className={"col-md-6 mb-2"}>
                <label htmlFor={"validationCustom1_6"}>כשרות</label>
                <span className={"explanation mediumst fullROw"}>טקסט חופשי</span>
                <div className={"input-group"}>
                    <input type="text" className={"form-control"} id={"validationCustom1_6"} placeholder={"כשרות"} value={txtBuisKosher}
                        onChange={(e) => { rest["txtBuisKosher"] = e.target.value; setTxtBuisKosher(e.target.value) }} />

                </div>
            </div>
            <div className={"col-md-6 mb-2"}>
                <label htmlFor={"validationCustom1_7"}>סוג מטבח</label>
                <span className={"explanation mediumst fullROw"}>טקסט חופשי</span>
                <div className={"input-group"}>
                    <input type="text" className={"form-control"} id={"validationCustom1_7"} placeholder={"סוג המטבח"} value={buissKitchType}
                        onChange={(e) => { rest["buissKitchType"] = e.target.value; setBuissKitchType(e.target.value) }} />
                </div>
            </div>
            <CatsCheckslist />



            <div className={"col-md-12 mb-2"}>
                <label htmlFor={"validationCustom1_2"}>טקסט אודות</label>
                <div className={"input-group"}>
                    <RichTextComp firstText={buissAbout}
                        saveEditorTxt={(content) => aboutTxtChanged(content)} />
                </div>
            </div>
            <div className={"col-md-12 mb-2"}>
                <label htmlFor={"validationCustom1_3"}>עוד טקסט</label>
                <div className={"input-group"}>

                    <RichTextComp firstText={buissMoreText}
                        saveEditorTxt={(content) => moreTxtChanged(content)} />
                </div>
            </div>
            <div className={"col-md-6 mb-2"}>
                <label htmlFor={"validationCustom1_7"}>סוג קופה</label>
                <div className={"CRTypeSelect"} style={{ margin: "unset" }}>
                    <CRTypeSelect restCRT={CRType ? CRType : "tablet"} onLeft={"onRight"}
                        CRTUpdate={(CRT) => { rest["CRType"] = CRT; setcRType(CRT) }} />
                </div>
            </div>

            <div className={"col-md-6 mb-2"}>

                <label htmlFor={"validationCustom1_7"}>מזהה לקופה</label>
                <div className={"input-group"}>
                    <input type="text" className={"form-control"} id={"validationCustom1_Cas"} placeholder={"cashRegId"} value={cashRegId}
                        onChange={(e) => { rest["cashRegId"] = e.target.value; setCashRegId(e.target.value) }} />

                </div>

            </div>

            <div className={"col-md-6 mb-2"}>

                <label htmlFor={"validationCustom1_6"}>gamma clientId</label>
                <div className={"input-group"}>
                    <input type="text" className={"form-control"} id={"validationCustom1_6"} placeholder={"clientId"} value={gammaCnt}
                        onChange={(e) => { rest["gammaCnt"] = e.target.value; setGammaCnt(e.target.value) }} />

                </div>
            </div>
            <div className={"col-md-6 mb-2"}>

                <label htmlFor={"validationCustom1_7"}>gamma Secret</label>
                <div className={"input-group"}>
                    <input type="text" className={"form-control"} id={"validationCustom1_7"} placeholder={"clientSecret"} value={gammaSecret}
                        onChange={(e) => { rest["gammaSecret"] = e.target.value; setGammaSecret(e.target.value) }} />
                </div>
            </div>
            <div className={"col-md-4 mb-3"}>

                <div className={"input-group switchMe"}>

                    <label className="ms-switch">
                        <input type="checkbox" id={"validationCustom5_3"} checked={gammaJ5}
                            onChange={(e) => { rest["gammaJ5"] = !gammaJ5; setGammaJ5(!gammaJ5) }} />
                        <span className="ms-switch-slider ms-switch-primary round" />
                    </label> <span className={"spHead bold"}>  gamma J5</span>

                </div>
            </div>
        </>

    );
}

export default TabBuisDetails;